import React, { useEffect } from 'react'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Routes,
  useSearchParams
} from 'react-router-dom'

import { AppRoutesWrapper } from 'components/AppRoutesWrapper'
import { AuthenticatedRoutes } from 'components/AuthenticatedRoutes'
import { AuthenticatedRoutesWrapper } from 'components/AuthenticatedRoutesWrapper'
import { UnauthenticatedRoutes } from 'components/UnauthenticatedRoutes'
import { UnauthenticatedRoutesWrapper } from 'components/UnauthenticatedRoutesWrapper'
import useAuth from 'hooks/use-auth'

const AppRoutes: React.FC = () => {
  const { currentTeamId, session, setActiveTeamId } = useAuth()
  const [searchParams] = useSearchParams()
  const hasSession = Boolean(session.company_id)
  const teamIdQueryParam = searchParams.get('teamId')

  useEffect(() => {
    if (!teamIdQueryParam || teamIdQueryParam === currentTeamId) return

    /**
     * In the following cases, set the active team to teamId from query params:
     * 1. session or teams is undefined (still fetching the session)
     * 2. the teamId exists in session.teams
     */
    if (
      !session?.teams ||
      session.teams.some((team) => team.identifier === teamIdQueryParam)
    ) {
      setActiveTeamId(teamIdQueryParam)
    }
  }, [currentTeamId, teamIdQueryParam, session.teams, setActiveTeamId])

  return (
    <Routes>
      {hasSession ? (
        <Route element={<AuthenticatedRoutesWrapper />}>
          <Route element={<AuthenticatedRoutes />} path="/*" />
        </Route>
      ) : (
        <Route element={<UnauthenticatedRoutesWrapper />}>
          <Route element={<UnauthenticatedRoutes />} path="/*" />
        </Route>
      )}
    </Routes>
  )
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppRoutesWrapper />}>
      <Route element={<AppRoutes />} path={'/*'} />
    </Route>
  )
)

const App: React.FC = () => <RouterProvider router={router} />

export default App
